import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/jump-for-gold/Index.vue')
const Rewards = () => import('../activity/jump-for-gold/Rewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/jump-for-gold',
  name: 'activity_jump_for_gold',
  component: Index,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '跳跳顶金币',
  },
}

export const rewardsRoute: RouteConfig = {
  path: '/activity/jump-for-gold-rewards',
  name: 'activity_jump_for_gold_rewards',
  component: Rewards,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '领取记录',
  },
}

export default [indexRoute, rewardsRoute]
